var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"status-badge",class:{
    'status-badge--small': _vm.small,
  },style:({
    backgroundColor: _vm.statusColor,
  })},[_c('i',{staticClass:"fa-fw",class:_vm.statusIcon}),_c('span',[_vm._v(" "+_vm._s(_vm.status || '---')+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }